var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect2, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43 10a6 6 0 0 1 6 6v4a6 6 0 0 1 -6 6h-34a6 6 0 0 1 -6-6v-4a6 6 0 0 1 6-6z",
    fill: "#59372d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43 10h-34a5.968 5.968 0 0 0 -3.119.881 5.968 5.968 0 0 0 -.881 3.119v4a6 6 0 0 0 6 6h34a5.968 5.968 0 0 0 3.119-.881 5.968 5.968 0 0 0 .881-3.119v-4a6 6 0 0 0 -6-6z",
    fill: "#6f483a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m50 38a6 6 0 0 0 -6-6h-36a6 6 0 0 0 -6 6v14a6 6 0 0 0 6 6h36a6 6 0 0 0 6-6z",
    fill: "#26669e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m44 32h-36a5.968 5.968 0 0 0 -3.119.881 5.968 5.968 0 0 0 -.881 3.119v14a6 6 0 0 0 6 6h36a5.968 5.968 0 0 0 3.119-.881 5.968 5.968 0 0 0 .881-3.119v-14a6 6 0 0 0 -6-6z",
    fill: "#307abe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18 41h16v8h-16z",
    fill: "#e4e5e7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m10 58v4h32v-4",
    fill: "#43525b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#43525b",
    height: 20,
    rx: 2,
    width: 4,
    x: 9,
    y: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m19 10v-6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6",
    fill: "#419bd7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#442821"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 13h26v2h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 21h26v2h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 17h26v2h-26z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m50 39h4v12h-4",
    fill: "#43525b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m54 49v-10h-2v8a2 2 0 0 0 2 2z",
    fill: "#69737a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m54 46v-2a7.008 7.008 0 0 0 7-7v-11a7.009 7.009 0 0 0 -7-7h-5v-2h5a9.011 9.011 0 0 1 9 9v11a9.01 9.01 0 0 1 -9 9z",
    fill: "#43525b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m16 26h20v6h-20z",
    fill: "#43525b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m18 26h18v4h-18z",
    fill: "#69737a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m44 32v26a6 6 0 0 0 6-6v-14a6 6 0 0 0 -6-6z",
    fill: "#91989d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m8 32v26a6 6 0 0 1 -6-6v-14a6 6 0 0 1 6-6z",
    fill: "#91989d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m7.057 32.081a6.052 6.052 0 0 0 -.653.14l-.071.019a6.042 6.042 0 0 0 -1.452.641 5.968 5.968 0 0 0 -.881 3.119v14a6 6 0 0 0 4 5.651v-23.651a6.028 6.028 0 0 0 -.765.054c-.06.008-.119.018-.178.027z",
    fill: "#aab1b7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m44 32v24h2a5.968 5.968 0 0 0 3.119-.881 6.042 6.042 0 0 0 .641-1.452c.007-.023.012-.047.019-.071a6.052 6.052 0 0 0 .14-.653c.009-.059.019-.118.027-.178a6.028 6.028 0 0 0 .054-.765v-14a6 6 0 0 0 -6-6z",
    fill: "#aab1b7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m10 60h32v2h-32z",
    fill: "#69737a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m11 8a1.987 1.987 0 0 0 -1 .277v15.723a1.988 1.988 0 0 0 3 1.723v-15.723a2 2 0 0 0 -2-2z",
    fill: "#69737a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#43525b",
    height: 20,
    rx: 2,
    width: 4,
    x: 39,
    y: 8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m41 8a1.987 1.987 0 0 0 -1 .277v15.723a1.988 1.988 0 0 0 3 1.723v-15.723a2 2 0 0 0 -2-2z",
    fill: "#69737a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m33 8v-4a2 2 0 0 0 -2-2h-10v6z",
    fill: "#4aaee3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase2);
export default __webpack_public_path__ + "static/media/Phase2.9b46f9b08197a717fb7bf20b9fb237c7.svg";
export { ForwardRef as ReactComponent };